import loading from '../helpers/loading'
import collectionPerPage from '../helpers/collectionPerPage'

import actions from './actions'

export default {
  namespaced: true,
  state: {
    ...loading.state,
    ...collectionPerPage.state,
    feedbacksError: null
  },
  mutations: {
    ...loading.mutations,
    ...collectionPerPage.mutations,
    feedbacksError: (state, { error }) => (state.feedbacksError = error)
  },
  getters: {
    ...loading.getters,
    ...collectionPerPage.getters
  },
  actions
}



// WEBPACK FOOTER //
// ./src/store/skiliko/feedbacks/index.js